import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';
import { BubbleContent } from 'components/customer/conversation_history/conversation_items_v2/content/bubble_content';
import ItemContent from 'components/customer/conversation_history/conversation_items_v2/item_content';
import ItemMetadata from 'components/customer/conversation_history/conversation_items_v2/item_metadata';
import VoiceAIPhoneMetadataIcon from 'components/lib/icons/voiceai_phone_metadata_icon';
import ConversationItem from 'models/conversation_item';
import styled from 'styled-components';
import InformationFillIcon from '../../../../common/icons/fill/information-fill';

export default function VoiceAIMessageItem({ className, isFirstInStack, isLastInStack, isStacked, item }) {
  return (
    <ItemContent
      isFirstInStack={isFirstInStack}
      isLastInStack={isLastInStack}
      isStacked={isStacked}
      item={item}
      showIcon={!isStacked}
    >
      <ItemMetadata
        appName={'Sidekick'}
        icon={<VoiceAIPhoneMetadataIcon />}
        item={item}
        showMetadata={!isStacked}
        text="said"
      />
      <BubbleContent
        className={classnames('voiceAIMessageItem-content', className)}
        data-aid={`voiceAIMessageItem-${item.id}`}
        item={item}
      >
        <div dir="auto">
          <InlineAnnotatedContentContainer
            hasRedactedPaymentCard={item.content.hasRedactedPaymentCardNumber}
            id={item.id}
            isRedacted={item.content.isRedacted}
            text={item.content.body}
          />
        </div>
        {item.content.isInterrupted() && (
          <StyledMessageInterruptedItem>
            <StyledMessageInterruptedIcon /> This message was interrupted
          </StyledMessageInterruptedItem>
        )}
      </BubbleContent>
    </ItemContent>
  );
}

VoiceAIMessageItem.propTypes = {
  className: PropTypes.string,
  isStacked: PropTypes.bool,
  isFirstInStack: PropTypes.bool,
  isLastInStack: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

const StyledMessageInterruptedItem = styled.span`
  align-items: center;
  color: ${p => p.theme.colors.gray600};
  display: flex;
  margin-right: 8px;
  margin-top: 4px;
  font-size: 12px;
`;

const StyledMessageInterruptedIcon = styled(InformationFillIcon)`
  display: inline-flex;
  fill: ${p => p.theme.colors.gray600};
  height: 14px;
  margin-right: 6px;
`;
